import Vue from 'vue';
import { debounce } from 'lodash-es';
import i18n from '@/i18n';

let messages = [];
function showToast() {
  messages.forEach(({ message, type }) => {
    Vue.toasted.show(i18n.t(message), {
      type: type,
      duration: 4000,
    });
  });
  messages = [];
}
const runDebounced = debounce(showToast, 400);

window.tost = () => {
  toastDebounced({
    type: 'success',
    message: 'Integration.klaviyo.updated',
  });
};

export function toastDebounced({ message, type }) {
  if (!messages.find(m => m.message === message)) {
    messages.push({ type, message });
  }
  runDebounced();
}
